import 'css-chunksrc/client/scenes/preferences/selectList/styles.scss';export default {
  "selectList": "_selectList_1024k_1",
  "opened": "_opened_1024k_6",
  "input": "_input_1024k_10",
  "selectedItems": "_selectedItems_1024k_25",
  "selectedItem": "_selectedItem_1024k_25",
  "list": "_list_1024k_44",
  "item": "_item_1024k_61",
  "selectedListItem": "_selectedListItem_1024k_73",
  "iconBox": "_iconBox_1024k_77",
  "icon": "_icon_1024k_77",
  "placeholder": "_placeholder_1024k_91",
  "invalid": "_invalid_1024k_106"
};